import type { SxProps, Theme } from '@mui/material/styles';

import { signupPageStyles, signupTypography } from '../../../pages/signup/SignupPage/SignupPage.styles';

export const signupProgramStepStyles = {
  selectFontSize: signupTypography.standard,
  stepContent: signupPageStyles.stepContent,
  fieldGroup: signupPageStyles.fieldGroup,
  actionError: signupPageStyles.actionError,
  continueButton: signupPageStyles.continueButton,
  sectionHeadingRow: (): SxProps<Theme> => ({
    display: 'flex',
    alignItems: { xs: 'flex-start', sm: 'center' },
    justifyContent: 'space-between',
    gap: 2,
    mb: 2.5,
    flexDirection: { xs: 'column', sm: 'row' },
  }),
  sectionHeading: (): SxProps<Theme> => ({
    fontSize: signupTypography.sectionHeading,
    fontWeight: 400,
  }),
  tokenToggle: (theme: Theme): SxProps<Theme> => ({
    minWidth: 0,
    p: 0,
    color: theme.palette.success.dark,
    fontSize: signupTypography.standard,
    fontWeight: 500,
    justifyContent: 'flex-start',
    '&:hover, &:focus, &:active': {
      bgcolor: 'transparent',
      border: 'none !important',
      outline: 'none !important',
      boxShadow: 'none !important',
    },
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:focus-visible': {
      outline: `3px solid ${theme.palette.success.light} !important`,
      outlineOffset: '4px',
    },
  }),
};
